module.exports = __webpack_public_path__ + "static/media/superman-static.0ad16810.png";